import Tooltip from 'rc-tooltip';
import 'rc-tooltip/assets/bootstrap.css';

export default Tooltip;



// WEBPACK FOOTER //
// ./src/components/Tooltip/index.js